import gql from 'graphql-tag';

export const RESPONSIBLE_TYPES = gql`
  query ResponsibleTypes {
    responsibleTypes {
      id
      name
    }
  }
`;
